import _ from "underscore";
import {PlaybookIssueset} from "common/types/issueset";
import {ContractType} from "../components/contract_types_list";

export const getTemplateIssueset = (
  clientIssueset: PlaybookIssueset,
  issuesets: PlaybookIssueset[],
): PlaybookIssueset | null => {
  if (!clientIssueset.remote_client_id) {
    return null;
  }
  return (
    issuesets.find(
      issueset =>
        !issueset.remote_client_id &&
        issueset.master_id === clientIssueset.master_id,
    ) || null
  );
};

export const getFilteredIssuesets = (
  contractType: ContractType | undefined,
  showArchived: boolean,
  isAdmin: boolean,
): PlaybookIssueset[] => {
  if (!contractType) {
    return [];
  }
  return _.chain(contractType.issuesets)
    .filter(
      issueset =>
        (!issueset.is_archived || showArchived) &&
        (isAdmin || !issueset.is_hidden),
    )
    .sortBy(
      issueset =>
        issueset.name +
        (issueset.remote_client_name ? issueset.remote_client_name : ""),
    )
    .value();
};
